import React from 'react';
import useStore from '../../../store';
import { useTranslation } from 'react-i18next';
import { FaEye, FaPencilAlt, FaCrosshairs, FaComment, FaGamepad, FaExclamationCircle, FaHeart, FaSearch } from 'react-icons/fa';
import './MafiaTopBar.css';

const MafiaTopBar = ({ timeLeft }) => {
    const { t } = useTranslation();
    const store = useStore.getState();
    const { mafia } = store.ref;

    // Подписка на рендер
    useStore(state => state.render);

    // Достаем word и team из состояния
    const { activeTab, phase, role, chats, availableTabs, hasDrawn, word, team } = mafia;

    // Хелпер для иконок
    const getIcon = (type, iconKey) => {
        switch (type) {
            case 'eye': return <FaEye />;
            case 'draw': return <FaPencilAlt />;
            case 'game': return <FaGamepad />;
            case 'chat': return <FaComment />;
            case 'action':
                if (iconKey === 'heal') return <FaHeart />;
                if (iconKey === 'search') return <FaSearch />;
                return <FaCrosshairs />;
            default: return <FaComment />;
        }
    };

    // Собираем финальный список
    const renderTabs = () => {
        const tabsToRender = [];

        // 1. Табы из конфигурации
        if (availableTabs) {
            availableTabs.forEach(tabDef => {
                let badge = 0;
                let alert = false;

                if (tabDef.id === 'chat_mafia') {
                    badge = chats['mafia']?.unreadCount || 0;
                }
                else if (tabDef.id === 'draw') {
                    if ((phase === 'draw_civilian' && role === 'civilian') ||
                        (phase === 'draw_mafia' && role === 'mafia')) {
                        alert = !hasDrawn;
                    }
                }

                // Определяем название таба
                let label = tabDef.labelKey ? t(tabDef.labelKey) : (tabDef.label || '');

                // --- ЛОГИКА: ЗАМЕНА "РИСОВАТЬ" НА СЛОВО ---
                // Если это таб "Рисовать", мы Мирный житель и знаем слово
                if (tabDef.id === 'draw' && team === 'town' && word) {
                    label = word;
                }

                tabsToRender.push({
                    ...tabDef,
                    icon: getIcon(tabDef.type, tabDef.iconKey),
                    label: label,
                    badge,
                    alert
                });
            });
        }

        // 2. Динамические чаты
        Object.values(chats || {}).forEach(chat => {
            if (chat.id === 'mafia' || chat.id === 'ghosts' || chat.id === 'general') return;

            // Пытаемся определить название
            let label = chat.title || t('mafia.hud.tab_chat');

            // --- ИЗМЕНЕНИЕ ---
            // Проверяем точное совпадение или наличие подстроки (на случай старых версий)
            if (chat.id === 'interrogation') {
                label = t('mafia.hud.tab_interrogation');
            }
            // -----------------

            tabsToRender.push({
                id: `chat_${chat.id}`,
                icon: <FaComment />,
                badge: chat.unreadCount,
                label: label
            });
        });

        return tabsToRender;
    };

    const finalTabs = renderTabs();

    // Логика отображения табов:
    // Если табов <= 3 -> режим "Иконка + Текст"
    // Если табов >= 4 -> режим "Только крупные иконки"
    const isCompactMode = finalTabs.length >= 5;

    // Форматирование времени
    const formatTime = (seconds) => {
        if (seconds <= 0) return "0:00";
        const m = Math.floor(seconds / 60);
        const s = seconds % 60;
        return `${m}:${s < 10 ? '0' : ''}${s}`;
    };

    return (
        <div className="mafia-top-bar">
            {/* СТРОКА 1: Таймер (слева) + Фаза (строго по центру) */}
            <div className="mtb-row-header">
                {/* Левая часть: Таймер и разделитель */}
                <div className="mtb-timer-container">
                    <span className={`mtb-timer ${timeLeft < 10 ? 'danger' : ''}`}>
                        {formatTime(timeLeft)}
                    </span>
                    <div className="mtb-header-divider"></div>
                </div>

                {/* Центр: Название фазы (абсолютное позиционирование) */}
                <div className="mtb-phase-container">
                    <span className="mtb-phase-title">
                        {t(`mafia.hud.phase_title_${phase}`)}
                    </span>
                </div>

                {/* Правая часть пустая для баланса или кнопки меню в будущем */}
                <div className="mtb-header-spacer"></div>
            </div>

            {/* СТРОКА 2 (бывшая 3): Табы */}
            {finalTabs.length > 0 && (
                <div className="mtb-row-tabs">
                    {finalTabs.map(tab => (
                        <button
                            key={tab.id}
                            className={`mtb-tab ${activeTab === tab.id ? 'active' : ''} ${isCompactMode ? 'icon-only' : 'with-text'}`}
                            onClick={() => mafia.methods.setActiveTab(tab.id)}
                        >
                            <span className="mtb-tab-icon">{tab.icon}</span>

                            {/* Текст показываем только если табов мало */}
                            {!isCompactMode && (
                                <span className="mtb-tab-label">{tab.label}</span>
                            )}

                            {tab.alert && <FaExclamationCircle className="mtb-alert-icon" />}
                            {tab.badge > 0 && <span className="mtb-badge">{tab.badge}</span>}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};
export default MafiaTopBar;